<template>
  <div class="box !p-0 box-25 last:mr-0 relative w-full">
    <div class="flex flex-wrap">
      <div class="flex flex-col items-center justify-center min-w-[75px] max-w-[75px] p-2 bg-g3">
        <svg xmlns=" http://www.w3.org/2000/svg" width="21.215" height="21.334" viewBox="0 0 21.215 21.334">
          <g transform="translate(0 11)">
            <path
              d="M4.552.005a4.549,4.549,0,0,1,4.543,4.28l.008.268H7.57A3.018,3.018,0,1,0,4.326,7.56l.226.009V9.1a4.548,4.548,0,1,1,0-9.1Zm0,12.1v1.532A3.035,3.035,0,1,0,7.561,16.88l.009-.226H9.1a4.551,4.551,0,1,1-4.817-4.54l.267-.008Zm12.11,0a4.615,4.615,0,1,1-4.544,4.815l-.007-.268h1.532a3.018,3.018,0,1,0,3.244-3.006l-.226-.009V12.107Zm0-12.1a4.548,4.548,0,0,1,.267,9.088l-.267.008V7.569a3.035,3.035,0,1,0-3.009-3.241l-.009.226H12.111A4.549,4.549,0,0,1,16.661.005ZM16.867,15.8a.832.832,0,1,1-1.112.933,3.287,3.287,0,0,0-.518-.6c-.17-.173-.579-.473-1.046-.842a6.643,6.643,0,0,0-3.546-1.7A5.561,5.561,0,0,0,7.682,14.9c-.244.17-.712.523-1.324.98a4.078,4.078,0,0,0-.973,1.083l-.008-.008a.836.836,0,1,1-.958-1.183,1.806,1.806,0,0,0,.9-.639,19.84,19.84,0,0,0,1.265-1.6,5.379,5.379,0,0,0,1.283-2.788,4.843,4.843,0,0,0-1.186-2.7c-.212-.315-.667-.9-1.126-1.465A4.53,4.53,0,0,0,4.22,5.357l0,0a.833.833,0,1,1,1.233-.874,5.187,5.187,0,0,0,1.13,1.273s1.023.768,1.283.939a5.055,5.055,0,0,0,5.776-.106c.591-.485,1.589-1.25,1.589-1.25a2.432,2.432,0,0,0,.506-.755.837.837,0,1,1,1.189.8h0a2.413,2.413,0,0,0-.847.774s-.529.742-1.17,1.561a5.365,5.365,0,0,0-1.432,3.14,5.425,5.425,0,0,0,1.535,3.027,9.543,9.543,0,0,0,1.258,1.488,2.3,2.3,0,0,0,.588.427Z"
              transform="translate(0 -11.005)" fill="#fff" fill-rule="evenodd" />
          </g>
        </svg>
        <span class="text-center text-balance leading-3 mt-3">
          {{ config.deviceFamilly.this_name }}
        </span>
      </div>
      <Videos_Externe :config="config" />
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import Videos_Externe from "@/partials/Video/Videos_Externe.vue";
export default {
  name: "Drone_Externe_Temporaire",
  components: {
    Videos_Externe,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
    };
  },

  async mounted() {

  },

  methods: {

  },
};
</script>
